import http from './http';

export type User = {
    id: number;
    name: string;
    email: string;
    role?: string;
    is_quality_profile?: boolean;
    is_admin_profile?: boolean;
    profile_name?: string;
    profiles?: UserProfile[];
    tenant?: UserTenant;
    impersonation?: ImpersonationInfo | null;
};

export type ImpersonationInfo = {
    impersonator_id: number;
    impersonator_name: string;
};

export type UserProfile = {
    id?: number;
    name: string;
};

export type UserTenant = {
    id?: number;
    name: string;
    folder: string;
};

export async function getCurrentUser(): Promise<User> {
    const response = await http.get<{ success: boolean; user: User }>('/api/auth/me');
    return response.data.user;
}
